/* eslint-disable react/no-unknown-property */
import { useNavigate } from 'react-router';
import { Button } from '../../ui/components/Button';
import styles from './Landing.module.scss';
import AppointmentImage from '../../ui/assets/images/apt/create_appointment_example.png';
import { Icon } from '../../ui/components/Icon/Icon';

export const Landing = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.root} color-palette="scheduler-2">
      <div className={styles.beta}>
        Prueba la aplicación en estado BETA gratuitamente
      </div>
      <div className={styles.header}>
        <div className={styles['left-header']}>
          <div className={styles.slogan}>
            <span>Simplifica</span> y <span>optimiza</span> la gestión de tu
            negocio con nuestra app
          </div>
          <div className={styles.buttons}>
            <Button onClick={() => navigate('/login')}>Inicia Sesión</Button>
            <Button btnStyle="secondary" onClick={() => navigate('/register')}>
              Crear Cuenta
            </Button>
          </div>
        </div>
        <div className={styles['right-header']}>
          <img src={AppointmentImage} alt="Logo" className={styles.logo} />
        </div>
      </div>
      <div className={styles.main}>
        <div className={styles.benefit}>
          <Icon type="headphones" />
          <div className={styles.content}>
            <div className={styles.title}>Atención rápida</div>
            <div className={styles.description}>
              Obtén respuestas inmediatas a tus preguntas y antención a tus
              necesidades de negocio. Tenemos capacidad de elaborar nuevas
              herramientas para volver tu negocio más eficiente.
            </div>
          </div>
          <Icon type="headphones" />
        </div>
        <div className={styles.benefit}>
          <Icon type="information" />
          <div className={styles.content}>
            <div className={styles.title}>Gestión de la información</div>
            <div className={styles.description}>
              Ten un registro de los movimientos de tu negocio. Podrás acceder a
              la información desde cualquier lugar y en cualquier momento,
              ayudandote para que puedas tomar mejores decisiones.
            </div>
          </div>
          <Icon type="information" />
        </div>
      </div>
    </div>
  );
};
